import React from "react";
import {
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import * as Scroll from "react-scroll";

const PassengerRules = (props) => {
  let scroll = Scroll.animateScroll;

  React.useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <div className="row">
      <div className="w-100 p-0" id="contact-div">
        <div className="container w-100 h-100 d-flex align-items-center">
          <h1 className="text-white">
            <b>حقوق مسافر اتوبوسی</b>
          </h1>
        </div>
      </div>

      <div className="container h-auto " style={{ marginBlock: "3rem" }}>
        <div
          className="container pt-5 bg-white landings-container"
        >
          <h2
            className="p-4 col-6 col-md-2"
            style={{ borderBottom: "2.3px solid #6dd06d" }}
          >
            <b>حرکت به موقع اتوبوس</b>
          </h2>
          <div className="d-flex flex-column mt-5 mb-20">
            <h3 style={{ lineHeight: "30px", marginBlock: "3rem" }}>
              طبق آخرین آمار, بیش از 90 درصد از حمل و نقل کشور از طریق جاده‌ها
              صورت می‌گیرد و 170 میلیون نفر در سال به وسیله حمل و نقل عمومی
              جاده‌ای سفر می‌کنند . همچنین 83 درصد از سفرهای بین شهری با اتوبوس
              انجام می‌شود,همین آمار اهمیت حمل و نقل جاده ای را به ما نشان می
              دهد.
            </h3>
            <h3 style={{ lineHeight: "30px", marginBlock: "0rem 4rem" }}>
              بر اساس متنی که در پایگاه اینترنتی سازمان راهداری و حمل و نقل جاده
              ای آمده است. مسافر حق دارد :
            </h3>
            <Accordion style={{ borderRadius: "13px", marginBlock: "1rem" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography
                  sx={{ width: "33%", flexShrink: 0, fontSize: "16px" }}
                >
                  1) بلیط مسافرتی / به‌نام مسافر
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  style={{
                    lineHeight: "30px",
                    fontSize: "16px",
                    paddingBlock: "10px",
                  }}
                >
                  " بلیط ,قرارداد حمل فی ما بین شركت و مسافر است كه بر اساس آن
                  شركت مسئول جابجایی مسافر از مبداء تا مقصد سفر در یك دوره زمانی
                  مشخص با وسیله نقلیه معین می باشد. " بلیط صادره متعلق به مسافر
                  می باشد و در صورت اخذ وجه و صدور بلیط ,ارایه سرویس حمل و نقل
                  و رساندن مسافر به مقصد مندرج در بلیط تكلیف شركت و حق مسافر است
                  . مسافر می تواند صدور بلیط دسته جمعی برای خود و همراهان خود را
                  از شركت مطالبه نماید . مسافران با سن كمتر از 2 سال حق بهره
                  مندی از سرویس رایگان حمل و نقل بین شهری را بدون اختصاص صندلی
                  دارا می باشند .
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion style={{ borderRadius: "13px", marginBlock: "1rem" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography
                  sx={{ width: "33%", flexShrink: 0, fontSize: "16px" }}
                >
                  2) دسترسی آسان به اطلاعات سفر
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  style={{
                    lineHeight: "30px",
                    fontSize: "16px",
                    paddingBlock: "10px",
                  }}
                >
                  اطلاعات سفر از قبیل نرخ خدمات ,نوع خدماتی كه مسافر می باید
                  دریافت نماید ,شناسائی نام راننده و مشخصات ناوگان مورد بهره
                  برداری ,مسیر سفر ,محل پیاده شدن ,محل های توقف برای نماز و
                  صرف غذا و... می باشد .
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion style={{ borderRadius: "13px", marginBlock: "1rem" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography
                  sx={{ width: "33%", flexShrink: 0, fontSize: "16px" }}
                >
                  3) انتخاب صندلی و شرکت مسافری
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  style={{
                    lineHeight: "30px",
                    fontSize: "16px",
                    paddingBlock: "10px",
                  }}
                >
                  بطور آزادانه نسبت به انتخاب شركت مسافربری و انتخاب صندلی جهت
                  صدور بلیت اقدام نماید.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion style={{ borderRadius: "13px", marginBlock: "1rem" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography
                  sx={{ width: "33%", flexShrink: 0, fontSize: "16px" }}
                >
                  4) پروانه فعالیت ارائه کننده خدمات
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  style={{
                    lineHeight: "30px",
                    fontSize: "16px",
                    paddingBlock: "10px",
                  }}
                >
                  به منظور حصول اطمینان از دریافت خدمات استاندارد ,پروانه
                  فعالیت ارائه كننده خدمات را رویت و مطالعه نماید . شركت ها
                  موظفند اصل پروانه فعالیت را در معرض دید و رویت مسافران قرار
                  دهند .
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion style={{ borderRadius: "13px", marginBlock: "1rem" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography
                  sx={{ width: "33%", flexShrink: 0, fontSize: "16px" }}
                >
                  5) شئونات اخلاقی و رفتاری{" "}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  style={{
                    lineHeight: "30px",
                    fontSize: "16px",
                    paddingBlock: "10px",
                  }}
                >
                  از رفتار مناسب و حسن برخورد و تكریم كاركنان شركت و رانندگان و
                  خدمه سرویس‌های مسافرتی برخوردار گشته و شئونات اخلاقی و اسلامی
                  و انسانی در محیط سفر های بین شهری درباره وی كاملاً رعایت گردد
                  .
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion style={{ borderRadius: "13px", marginBlock: "1rem" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography
                  sx={{ width: "33%", flexShrink: 0, fontSize: "16px" }}
                >
                  6) ارائه خدمات بدون وقفه
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  style={{
                    lineHeight: "30px",
                    fontSize: "16px",
                    paddingBlock: "10px",
                  }}
                >
                  از خدمات به موقع و بدون تاخیر بهره مند گردد . در صورت بروز
                  تاخیر در حركت وسیله نقلیه در زمان تعیین شده ,شركت مكلف است در
                  اسرع وقت و حداكثر تا یك ساعت نسبت به جایگزینی وسیله نقلیه
                  مناسب اقدام نماید . شركت می باید مسافرین را در زمان مناسب و
                  معمول و با پرهیز از ایجاد تاخیرهای غیر معمول در حین سفر و خارج
                  شدن ناوگان از مسیر اصلی برای مسافرگیری و ... به مقصد برساند .
                </Typography>
              </AccordionDetails>
            </Accordion>{" "}
            <Accordion style={{ borderRadius: "13px", marginBlock: "1rem" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography
                  sx={{ width: "33%", flexShrink: 0, fontSize: "16px" }}
                >
                  7) استرداد بلیط
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  style={{
                    lineHeight: "30px",
                    fontSize: "16px",
                    paddingBlock: "10px",
                  }}
                >
                  در چار چوب مقررات نسبت به انصراف از سفر و استرداد بلیت خود
                  اقدام نماید . در صورت انصراف مسافر از سفر ,بهاء بلیت تا یك
                  ساعت قبل از حركت 90% و بعد از آن 50% از كل مبلغ بلیت باید به
                  مسافر مسترد گردد . در صورت بروز تاخیر بیش از یك ساعت در اعزام
                  وسیله نقلیه و بنا به درخواست مسافر ,كل مبلغ بلیت می باید به
                  مسافر مسترد گردد .
                </Typography>
              </AccordionDetails>
            </Accordion>{" "}
            <Accordion style={{ borderRadius: "13px", marginBlock: "1rem" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography
                  sx={{ width: "33%", flexShrink: 0, fontSize: "16px" }}
                >
                  9) پروتکل های بهداشتی
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  style={{
                    lineHeight: "30px",
                    fontSize: "16px",
                    paddingBlock: "10px",
                  }}
                >
                  از خدمات مطلوب و كاملاً بهداشتی در محیط سفر های بین شهری بهره
                  مند گردد . به ویژه توزیع آب آشامیدنی می باید بوسیله ظروف یكبار
                  مصرف صورت پذیرد و تهیه و توزیع مواد خوراكی از مراكز دارای مجوز
                  بهداشتی معتبر و با استفاده از مواد بسته بندی شده دارای پروانه
                  ساخت و دارای تاریخ مصرف معتبر صورت پذیرد .
                </Typography>
              </AccordionDetails>
            </Accordion>{" "}
            <Accordion style={{ borderRadius: "13px", marginBlock: "1rem" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography
                  sx={{ width: "33%", flexShrink: 0, fontSize: "16px" }}
                >
                  10) بیمه مسافر
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  style={{
                    lineHeight: "30px",
                    fontSize: "16px",
                    paddingBlock: "10px",
                  }}
                >
                  از سفری ایمن و با رعایت كامل اصول ایمنی و دارای پوشش بیمه ای
                  مناسب بهره مند گردد . در محل های مجاز ( بغیر از اطراف پایانه
                  های مسافری ) و با رعایت اصول ایمنی و مقررات ترافیكی از وسیله
                  نقلیه پیاده شود .
                </Typography>
              </AccordionDetails>
            </Accordion>{" "}
            <Accordion style={{ borderRadius: "13px", marginBlock: "1rem" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography
                  sx={{ width: "33%", flexShrink: 0, fontSize: "16px" }}
                >
                  11) توقف در سفر
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  style={{
                    lineHeight: "30px",
                    fontSize: "16px",
                    paddingBlock: "10px",
                  }}
                >
                  در مكان های مناسب و به مدت لازم برای انجام فرایض دینی و همچنین
                  صرف غذا در حین سفر توقف نماید . با توجه به طول زمان و بعد
                  مسافت سفر,توقف در زمان های مناسب بین مسیر حق مسافر است و
                  رانندگان می باید جهت تامین نیازهای ضروری مسافرین و رفاه حال
                  آنان با مسافران و بویژه گروه سالمندان و كودكان و بیماران
                  مساعدت و همراهی لازم را بنمایند .
                </Typography>
              </AccordionDetails>
            </Accordion>{" "}
            <Accordion style={{ borderRadius: "13px", marginBlock: "1rem" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography
                  sx={{ width: "33%", flexShrink: 0, fontSize: "16px" }}
                >
                  12) بلیط سفر
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  style={{
                    lineHeight: "30px",
                    fontSize: "16px",
                    paddingBlock: "10px",
                  }}
                >
                  پس از اتمام عملیات فروش اینترنتی بلیت ,پیام كوتاه جهت تایید
                  خرید بلیت دریافت و تصویر چاپی بلیت خریداری شده را دریافت دارد
                  .
                </Typography>
              </AccordionDetails>
            </Accordion>{" "}
            <Accordion style={{ borderRadius: "13px", marginBlock: "1rem" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography
                  sx={{ width: "33%", flexShrink: 0, fontSize: "16px" }}
                >
                  13) تجهیزات و امکانات رفاهی
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  style={{
                    lineHeight: "30px",
                    fontSize: "16px",
                    paddingBlock: "10px",
                  }}
                >
                  با رعایت حال سایر مسافرین از تجهیزات و امكانات رفاهی وسیله
                  نقلیه از قبیل كولر ,بخاری ,آبسرد كن ,تلویزیون و... بهره مند
                  گردد. در صورت پخش و نمایش محصولات سمعی و بصری ,شركت مكلف است
                  از محصولات مجاز و با رعایت حقوق تولید كنندگان آن و سایر مقررات
                  مربوطه استفاده نماید .
                </Typography>
              </AccordionDetails>
            </Accordion>{" "}
            <Accordion style={{ borderRadius: "13px", marginBlock: "1rem" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography
                  sx={{ width: "33%", flexShrink: 0, fontSize: "16px" }}
                >
                  14) شکایات,انتقادات,پیشنهادات
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  style={{
                    lineHeight: "30px",
                    fontSize: "16px",
                    paddingBlock: "10px",
                  }}
                >
                  شكوائیه خود از عملكرد حمل و نقلی شركت ,راننده و كاركنان آن را
                  حداكثر تا یك ماه پس از تاریخ سفر در مراجع حمل و نقلی مربوطه از
                  قبیل ادارات كل راهداری و حمل و نقل جاده ای مطرح و ثبت نموده و
                  به نظام كارآمد رسیدگی به شكایات دسترسی داشته باشد . شركت حمل و
                  نقل مكلف است مدیر پاسخگو را در زمان ارائه خدمات به مسافران در
                  محل سرویس دهی بكارگیرد و شماره تلفن پاسخگوئی شركت و شماره
                  سامانه پیام كوتاه 3000143 را در ظهر بلیت و در داخل وسیله نقلیه
                  در معرض دید مسافران درج نماید .
                </Typography>
              </AccordionDetails>
            </Accordion>{" "}
            <Accordion style={{ borderRadius: "13px", marginBlock: "1rem" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography
                  sx={{ width: "33%", flexShrink: 0, fontSize: "16px" }}
                >
                  15) مشکل فنی در طول سفر
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  style={{
                    lineHeight: "30px",
                    fontSize: "16px",
                    paddingBlock: "10px",
                  }}
                >
                  هرگاه وسیله نقلیه در طول مسیر سفر به هر علت از كار بازماند ،
                  امكان ادامه مسافرت با وسیله نقلیه مناسب در اسرع وقت و بدون
                  ایجاد هزینه ای اضافی از سوی شركت برای وی فراهم گردد .
                </Typography>
              </AccordionDetails>
            </Accordion>{" "}
            <Accordion style={{ borderRadius: "13px", marginBlock: "1rem" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography
                  sx={{ width: "33%", flexShrink: 0, fontSize: "16px" }}
                >
                  16) حمل بار
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  style={{
                    lineHeight: "30px",
                    fontSize: "16px",
                    paddingBlock: "10px",
                  }}
                >
                  توشه همراه خود را تا سقف وزنی 20 كیلوگرم بصورت رایگان در سفر
                  های بین شهری حمل نماید (هزینه حمل اوزان بیشتر با توجه به ابعاد
                  و وزن توشه توافقی است). حداكثر وزن مجاز توشه همراه هر مسافر 40
                  كیلوگرم می باشد و مسئولیت حفظ و حراست از توشه و جبران كلیه
                  خسارات وارده به توشه تحویل شده به شركت یا فقدان آن بر عهده
                  شركت و راننده تحت پوشش است . شركت می باید برچسب شماره دار توشه
                  را كه شماره آن در بلیت درج شده است بعنوان رسید توشه به مسافر
                  تحویل نماید . پذیرش توشه همراه مسافر در تاریخ حركت مندرج در
                  بلیت بطور رایگان و نگهداری و حفاظت از آن تا قبل از آغاز سفر و
                  حمل ویلچر همراه مسافران معلول بطور رایگان تكلیف شركت و حق
                  مسافر است .
                </Typography>
              </AccordionDetails>
            </Accordion>{" "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PassengerRules;
